// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1LEEa","sendOtp":"AuthorizeToLogin_sendOtp__1eD6A"};